import moment from 'moment';

export const DateTimeFormatter = class DateTimeFormatter {
  /**
   *
   * @param {*} date
   */
  static formatWithTime(date) {
    return moment(date).format('YYYY.DD.MM hh:mm:ss');
  }

  /**
   *
   * @param {*} date
   */
  static formatDate(date) {
    return moment(date).format('YYYY.DD.MM');
  }
};
